export default {"src":"/_next/static/media/busd.7dea3e2a.svg","height":337,"width":336,"blurWidth":0,"blurHeight":0};